import { loadStripe } from '@stripe/stripe-js';

//export const stripePromise = loadStripe('pk_test_51HbE38Ae4RmulGTn2nGoaukH9vlJfAq6VzmUJp2qHY7ov3JvPJmeSfdZp2pxrWcfGMOghvDIqzbee0mmrS20xkHp00QJVh1Ifw');
export const stripePromise = loadStripe('pk_live_51HbE38Ae4RmulGTnHBRdTwrOFECBDvV2D8Mmx7QyduiZIgDL89rNqmzOj5x94dSgUbsG8GcRzbnSyj2aLcMKWgmf00MpvTTUEh');